<template>
  <div class="currencyField">
    <div class="currencyText">
      <v-text-field :label="label" :placeholder="placeholder" :rules="amountRules" type="number" v-model="currentValue"></v-text-field>
    </div>
    <v-menu bottom :close-on-click="true" :disabled="!currencies || currencies.length <= 1 || disabled">
      <template v-slot:activator="{ on, attrs }">
        <div class="currencySelector" v-bind="attrs" v-on="on">
          <span class="selectorCurrencyContent">
            <span class="flagImageCountrySearch">
              <v-img class="flagImageCountrySearch" :src="currentCountry.flag"  alt=""/>
            </span>
            <span class="searchCountrytext" v-text="currentCountry.currency"></span>
            <i v-if="currencies && currencies.length > 1 && !disabled" aria-hidden="true" class="v-icon material-icons theme--light error--text searchArrowDropDown">arrow_drop_down</i>
          </span>
        </div>
      </template>
      <v-list>
        <template v-for="(item, index) in currencies">
          <v-hover v-slot:default="{ hover }" :key="index">
            <v-list-tile :class="hover ? 'elevation-2' : ''" @click="currencyChanged(item)">
              <v-list-tile-action class="pa-1">
                <v-img class="flagImageCountrySearch" :src="item.flag" :alt="item.currency" />
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.currency }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-hover>
        </template>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  data () {
    return {
      amountRules: [
        v => !v || v.length === 0 || !this.minAmount || parseFloat(v) > parseFloat(this.minAmount) || this.$t('CurrencyInputField.MIN_AMOUNT_ERROR_MSG', { amount: `${this.minAmount}` }),
        v => !v || v.length === 0 || !this.maxAmount || parseFloat(v) <= parseFloat(this.maxAmount) || this.$t('CurrencyInputField.MAX_AMOUNT_ERROR_MSG', { amount: `${this.maxAmount}` })
      ]
    }
  },
  props: ['value', 'currencies', 'label', 'placeholder', 'currency', 'disabled', 'backgroundColor', 'maxAmount', 'minAmount'],
  methods: {
    currencyChanged (currency) {
      this.$emit('selectedCurrencyChanged', currency)
    }
  },
  mounted () {
    $('.currencyText .v-input__slot').css('background-color', this.backgroundColor)
    $('.currencySelector').css('background-color', this.backgroundColor)
  },
  computed: {
    currentValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    currentCountry: function () {
      let currencyFlag = require('@/assets/img/flags/unknown.png')
      if (!!this.currency && !!this.currency.currency) {
        try {
          currencyFlag = require(`@/assets/img/flags/currencies/${this.currency.currency.toLowerCase()}.png`)
        } catch {
          console.log(`Currency flag not found for ${this.currency.currency}`)
          console.debug(this.currency)
        }
        return { currency: this.currency.currency.toUpperCase(), flag: currencyFlag }
      } else { return { currency: 'NA', flag: currencyFlag } }
    }
  }
}
</script>

<style>
.currencySelector {
    height: 40px;
    margin-top: 18px;
    border: 1px solid #d4d9e1;
    border-left: 0px;
    border-bottom-right-radius : 5px !important;
    border-top-right-radius: 5px !important;
    width: 87px;
    cursor: pointer;
}
.currencyField {
    display: inline-flex;
    width: 100%;
}
.currencyText .v-input__slot {
  border-radius: 0px !important;
  border-bottom-left-radius: 5px !important;
  border-top-left-radius: 5px !important;
}
.currencyText {
    width: 100%
}
.selectorCurrencyContent{
    margin-left: 9px;
    margin-top: 9px;
    display: flex;
}
</style>
